export enum ReportNames {
	GenericSSRSReport = 'Generic SSRS Report',
	HighSchoolTranscript = 'High School Transcript',
	HonorRollCertificate = 'Honor Roll Certificate',
	HonorRollList = 'Honor Roll List',
	MissingLateIncompleteAssignmentsByStudent = 'Missing Late Incomplete Assignments By Student',
	ReportCardV2 = 'Report Card',
	ProgressReportV2 = 'Progress Report'
}
